// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"6bfeff0c3791257106b2","678":"245405a7d183a8492fc6","883":"cac852f7317fecb41a05"}[chunkId] + ".js";
};